export const GET_INSTALLMENTS = "GET_INSTALLMENTS"
export const GET_INSTALLMENTS_SUCCESS = "GET_INSTALLMENTS_SUCCESS"
export const GET_INSTALLMENTS_FAIL = "GET_INSTALLMENTS_FAIL"

export const INITIALIZE_PAY_DATA = "INITIALIZE_PAY_DATA"
export const INITIALIZE_PAY_DATA_SUCCESS = "INITIALIZE_PAY_DATA_SUCCESS"
export const INSTALLMENT_API_ERROR = "INSTALLMENT_API_ERROR"